<div class="container-fluid px-0">
    <div class="">
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs gap-02 overflow-auto d-flex flex-nowrap align-items-center overflow">
            <li *ngFor="let tab of tabData" [ngbNavItem]="tab.id" class="pb-1"
            [ngStyle]="{'border-bottom': active === tab.id ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                <div class="hand secondary-text pe-2 text-nowrap"
                 [ngClass]="active === tab.id ? 'text-primary-color' :  'text-light-gray'"
                  (click)="activeTab(tab.id)"
                  ngbNavLink>
                  {{ tab.label }}
                </div>
                <ng-template ngbNavContent>
                    <app-ag-grid 
                    [style.height]="'20.5rem'"
                    class="doc-grid d-flex flex-column position-relative center-Pagination"
                    id="partList"
                    [dataModel]="tab.dataModel"
                    (gridReady)="onGridReady($event)"
                    [columnSettings]="false" 
                    [paginations]="tab.pagination" 
                    [getRowStyle]="getRowStyle"
                    (onImageIconClick)="onImageIconClick($event)"
                    (onSerialNumberClick)="onSerialNumberClick($event)"
                    (onPagination)="onPagination($event)"
                  ></app-ag-grid>  
                </ng-template>
              </li>
        </ul>
        <div [ngbNavOutlet]="nav" class=""></div>
    </div>

</div>